import React from 'react';
import Tilty from 'react-tilty';
import { useLanguage } from '../../context/LanguageContext';
import { Features } from '../../assets/features/Features';

const BcrumbBannerOne = ({title, paragraph, styleClass, mainThumb}) => {
    const { language } = useLanguage();
    
    // Determine which animation to show based on title/context
    // This is a simple way to switch animations without changing the component props structure deeply
    const renderAnimation = () => {
        const titleUpper = title.toUpperCase();
        
        if (titleUpper.includes("SOBRE") || titleUpper.includes("ABOUT")) {
            return (
                <div className="banner-animation-about">
                    <svg viewBox="0 0 500 400" className="banner-svg" style={{overflow: 'visible'}}>
                        <defs>
                            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" style={{stopColor: '#2f96d4', stopOpacity: 1}} />
                                <stop offset="100%" style={{stopColor: '#1e7ba8', stopOpacity: 1}} />
                            </linearGradient>
                        </defs>
                        {/* Team/People Abstract */}
                        <g transform="translate(0, 0)">
                            <circle cx="0" cy="0" r="30" fill="#7bc5e8" className="head-bounce"/>
                            <path d="M-40 80 Q 0 40 40 80 L 40 140 L -40 140 Z" fill="#5ab3e0"/>
                        </g>
                        <g transform="translate(100, 30)">
                            <circle cx="0" cy="0" r="35" fill="#9dd4f0" className="head-bounce-2"/>
                            <path d="M-45 80 Q 0 40 45 80 L 45 150 L -45 150 Z" fill="#6bb8e5"/>
                        </g>
                        <g transform="translate(200, 0)">
                            <circle cx="0" cy="0" r="30" fill="#7bc5e8" className="head-bounce-3"/>
                            <path d="M-40 80 Q 0 40 40 80 L 40 140 L -40 140 Z" fill="#5ab3e0"/>
                        </g>
                        
                        {/* Connection Lines */}
                        <path d="M0 0 Q 100 -30 200 0" fill="none" stroke="#ccc" strokeWidth="2" strokeDasharray="5,5" className="connect-line"/>
                    </svg>
                    <style jsx>{`
                        .banner-animation-about { 
                            width: 100%; 
                            height: 100%;
                            min-height: 400px;
                            display: block;
                            position: relative;
                        }
                        .banner-svg {
                            width: 100%;
                            height: 100%;
                            min-height: 400px;
                            display: block;
                        }
                        .head-bounce { 
                            animation: bounceHead 3s ease-in-out infinite;
                            transform-origin: center;
                        }
                        .head-bounce-2 { 
                            animation: bounceHead 3s ease-in-out infinite 0.5s;
                            transform-origin: center;
                        }
                        .head-bounce-3 { 
                            animation: bounceHead 3s ease-in-out infinite 1s;
                            transform-origin: center;
                        }
                        @keyframes bounceHead {
                            0%, 100% { transform: translateY(0); }
                            50% { transform: translateY(-10px); }
                        }
                        .connect-line { animation: dash 3s linear infinite; }
                        @keyframes dash { to { stroke-dashoffset: -20; } }
                    `}</style>
                </div>
            );
        } else if (titleUpper.includes("DICA") || titleUpper.includes("TIP")) {
             return (
                <div className="banner-animation-tips">
                    <svg viewBox="0 0 500 400" className="banner-svg">
                         {/* Lightbulb Idea */}
                         <g transform="translate(250, 200)">
                            <path d="M-40 -60 C-40 -90 40 -90 40 -60 C40 -40 20 -20 20 0 L 20 20 L -20 20 L -20 0 C-20 -20 -40 -40 -40 -60" fill="#f1c40f" opacity="0.9" className="bulb-pulse"/>
                            <rect x="-15" y="20" width="30" height="10" fill="#95a5a6"/>
                            <rect x="-15" y="32" width="30" height="10" fill="#95a5a6"/>
                             
                             {/* Rays */}
                             <line x1="0" y1="-100" x2="0" y2="-130" stroke="#f1c40f" strokeWidth="5" className="ray"/>
                             <line x1="60" y1="-80" x2="80" y2="-100" stroke="#f1c40f" strokeWidth="5" className="ray"/>
                             <line x1="-60" y1="-80" x2="-80" y2="-100" stroke="#f1c40f" strokeWidth="5" className="ray"/>
                         </g>
                         
                         {/* Checklist items floating */}
                         <rect x="50" y="100" width="120" height="150" rx="5" fill="#fff" stroke="#eee" strokeWidth="2" transform="rotate(-10 110 175)"/>
                         <path d="M70 140 L80 150 L100 130" fill="none" stroke="#2ecc71" strokeWidth="3"/>
                         <line x1="110" y1="140" x2="150" y2="140" stroke="#ccc" strokeWidth="2"/>
                    </svg>
                    <style jsx>{`
                        .banner-animation-tips { 
                            width: 100%; 
                            height: 100%;
                            min-height: 400px;
                            display: block;
                            position: relative;
                        }
                        .banner-svg {
                            width: 100%;
                            height: 100%;
                            min-height: 400px;
                            display: block;
                        }
                        .bulb-pulse { animation: pulseBulb 2s ease-in-out infinite; }
                        @keyframes pulseBulb { 0% { opacity: 0.7; } 50% { opacity: 1; } 100% { opacity: 0.7; } }
                        .ray { animation: flashRay 2s ease-in-out infinite; }
                        @keyframes flashRay { 0% { opacity: 0.3; } 50% { opacity: 1; } 100% { opacity: 0.3; } }
                    `}</style>
                </div>
            );
        } else if (titleUpper.includes("SERVIÇO") || titleUpper.includes("SERVICE")) {
             return (
                <div className="banner-animation-services">
                    <svg viewBox="0 0 500 400" className="banner-svg">
                        {/* Gears */}
                        <g transform="translate(150, 150)" className="gear-spin">
                            <path d="M-40 -10 L-40 10 L-25 10 L-20 25 L-30 35 L-15 50 L0 40 L15 50 L25 35 L15 25 L20 10 L40 10 L40 -10 L25 -10 L20 -25 L30 -35 L15 -50 L0 -40 L-15 -50 L-25 -35 L-15 -25 L-20 -10 Z" fill="#3498db"/>
                            <circle cx="0" cy="0" r="10" fill="#fff"/>
                        </g>
                        <g transform="translate(240, 220)" className="gear-spin-rev">
                            <path d="M-50 -12 L-50 12 L-30 12 L-25 30 L-35 40 L-20 55 L0 45 L20 55 L35 40 L25 30 L30 12 L50 12 L50 -12 L30 -12 L25 -30 L35 -40 L20 -55 L0 -45 L-20 -55 L-35 -40 L-25 -30 L-30 -12 Z" fill="#e67e22"/>
                            <circle cx="0" cy="0" r="12" fill="#fff"/>
                        </g>
                        
                        {/* Transport Box */}
                         <g transform="translate(350, 150)">
                            <rect x="0" y="0" width="80" height="80" fill="#f39c12" className="box-delivery"/>
                            <text x="40" y="45" textAnchor="middle" fill="#fff" fontSize="12">{Features.COMMON.DELIVERY[language]}</text>
                         </g>
                    </svg>
                    <style jsx>{`
                        .banner-animation-services { 
                            width: 100%; 
                            height: 100%;
                            min-height: 400px;
                            display: block;
                            position: relative;
                        }
                        .banner-svg {
                            width: 100%;
                            height: 100%;
                            min-height: 400px;
                            display: block;
                        }
                        .gear-spin { animation: rotate 6s linear infinite; }
                        .gear-spin-rev { animation: rotate 6s linear infinite reverse; }
                        @keyframes rotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                        .box-delivery { animation: pop 3s ease-in-out infinite; transform-origin: center; }
                        @keyframes pop { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
                    `}</style>
                </div>
            );
        } else if (titleUpper.includes("CONTACTE") || titleUpper.includes("CONTACT")) {
            return (
                <div className="banner-animation-contact">
                    <svg viewBox="0 0 500 400" className="banner-svg">
                        {/* Phone Handset */}
                        <g transform="translate(250, 200) rotate(-45)">
                            <rect x="-30" y="-80" width="60" height="160" rx="10" fill="#2c3e50" className="phone-shake"/>
                            <rect x="-25" y="-75" width="50" height="150" fill="#ecf0f1"/>
                            <circle cx="0" cy="60" r="5" fill="#bdc3c7"/>
                        </g>
                        
                        {/* Speech Bubbles */}
                        <g className="bubble-1" transform="translate(320, 100)">
                            <ellipse cx="0" cy="0" rx="40" ry="30" fill="#3498db"/>
                            <path d="M-10 20 L10 20 L-20 40 Z" fill="#3498db"/>
                            <text x="0" y="5" textAnchor="middle" fill="#fff" fontSize="20">{Features.COMMON.HELLO[language]}</text>
                        </g>
                         <g className="bubble-2" transform="translate(150, 150)">
                            <ellipse cx="0" cy="0" rx="40" ry="30" fill="#2ecc71"/>
                            <path d="M10 20 L-10 20 L20 40 Z" fill="#2ecc71"/>
                            <text x="0" y="5" textAnchor="middle" fill="#fff" fontSize="20">{Features.COMMON.HI[language]}</text>
                        </g>
                    </svg>
                    <style jsx>{`
                        .banner-animation-contact { 
                            width: 100%; 
                            height: 100%;
                            min-height: 400px;
                            display: block;
                            position: relative;
                        }
                        .banner-svg {
                            width: 100%;
                            height: 100%;
                            min-height: 400px;
                            display: block;
                        }
                        .phone-shake { animation: shake 0.5s ease-in-out infinite; transform-origin: center; }
                        @keyframes shake { 0% { transform: rotate(0deg); } 25% { transform: rotate(2deg); } 75% { transform: rotate(-2deg); } 100% { transform: rotate(0deg); } }
                        .bubble-1 { animation: floatBubble 3s ease-in-out infinite; }
                        .bubble-2 { animation: floatBubble 3s ease-in-out infinite 1.5s; }
                        @keyframes floatBubble { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
                    `}</style>
                </div>
            );
        }
        
        // Default Image Fallback
        return (
            <Tilty perspective={2000} reset={false}>
                <img src={process.env.PUBLIC_URL + mainThumb} alt="Illustration" />
            </Tilty>
        );
    };

    return (
        <div className="breadcrum-area breadcrumb-banner">
            <div className="container">
                <div className="section-heading heading-left">
                    <h1 className="title h2" dangerouslySetInnerHTML={{__html: title}}></h1>
                    <p dangerouslySetInnerHTML={{__html: paragraph}}></p>
                </div>
                <div className={`banner-thumbnail ${styleClass}`}>
                    {renderAnimation()}
                </div>
            </div>
            <ul className="shape-group-8 list-unstyled">
                <li className="shape shape-1">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"} alt="Bubble" />
                </li>
                <li className="shape shape-2">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-21.png"} alt="Bubble" />
                </li>
                <li className="shape shape-3">
                    <img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" />
                </li>
            </ul>
            <style jsx>{`
                @media (max-width: 991px) {
                    .banner-thumbnail {
                        display: none !important;
                    }
                }
                .breadcrumb-banner .shape-group-8 .shape img {
                    filter: brightness(0) saturate(100%) invert(58%) sepia(89%) saturate(1352%) hue-rotate(180deg) brightness(120%) contrast(85%);
                    opacity: 0.25;
                }
            `}</style>
        </div>
    )
}

export default BcrumbBannerOne;